<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <!-- Room Service Recepient -->
    <div class="cf-flex cf-flex--column cf-flex--gap-8">
      <h3 class="cf-title cf-title--3">
        Delivery To:
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        Room Number: <b>{{ receipt.sublocationId }}</b>
      </p>

      <p class="cf-subtitle cf-subtitle--2">
        Guest: <b>{{ receipt.guestName }}</b>
      </p>
    </div>

    <cf-title-separator :omit-title="true" />

    <!-- Room Service Sender -->
    <div class="cf-flex cf-flex--column cf-flex--gap-8">
      <h3 class="cf-title cf-title--3">
        Delivered From:
      </h3>

      <cf-receipt-from-location-details :store="receipt.store" />
    </div>

    <!-- Room Service Pickup Instructions -->
    <template v-if="receipt.pickupInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <h3 class="cf-title cf-title--3">
          Additional Info:
        </h3>

        <cf-formatted-content
          class="dark"
          :content="receipt.pickupInstructions"
        />
      </div>
    </template>

    <cf-title-separator :omit-title="true" />
  </div>
</template>


<script>
  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfReceiptFromLocationDetails from '@/view/components/globals/cf-receipt-from-location-details/index.vue';
  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'RoomServiceReceiptFulfillmentDetails',

    components: {
      CfTitleSeparator,
      CfReceiptFromLocationDetails,
      CfFormattedContent
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    }
  };
</script>
